<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 10px">Kampanyalar</h3>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive" style="height: 600px">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <div class="row">
            <div class="col-2" v-for="data in datas" :key="data.id">
              <div class="card card-outline">
                <img
                  class="card-img-top"
                  :src="
                    'https://marketing.gorselcdn.com/promosyon/' + data.image
                  "
                  alt="Card image cap"
                />
                <div class="card-body">
                  <h5 class="card-title" v-html="data.name"></h5>

                  <button
                    class="btn btn-primary btn-sm float-right form-control"
                    @click="getTabs(data.id)"
                    style="margin-top: 10px"
                  >
                    Detaylar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>

    <div class="modal fade" id="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Kampanya Detayları</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="promotion-tab" role="tablist">
              <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                <a
                  class="nav-link active"
                  :id="'promotion-tab-' + index"
                  data-toggle="pill"
                  :href="'#tab-' + index"
                  role="tab"
                  :aria-controls="'tab-' + index"
                  aria-selected="true"
                  >{{ tab.tabHead }}</a
                >
              </li>
            </ul>

            <div class="tab-content" id="promotion-tab">
              <div
                v-for="(tab, index) in tabs"
                :key="index"
                class="tab-pane fade active show"
                :id="'tab-' + index"
                role="tabpanel"
                :aria-labelledby="'promotion-tab-' + index"
                v-html="tab.tabText"
              ></div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Kapat
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["customer"],
  data() {
    return {
      datas: [],
      tabs: [],
      overlay: false,
    };
  },

  methods: {
    getDatas() {
      this.overlay = true;
      this.$http
        .get("Promotion/ListCustomerPromotion/" + this.customer.code)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
    getTabs(id) {
      this.$http.get("Promotion/ListPromotionTab/" + id).then((response) => {
        this.tabs = response.data;
        $("#modal").modal();
      });
    },
  },

  created() {
    this.getDatas();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerPromotion.vue